import { jsx as _jsx } from "react/jsx-runtime";
import segment from 'lib-shared-segment';
import { memo, useCallback, useMemo, useState } from 'react';
import { useMount, useUpdateEffect } from 'react-use';
import { conversationsApi, } from 'apis/conversations';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { ConversationSummary, } from '../conversationSummary';
/** Represents the component for displaying summary of a conversation. */
export const ConversationSummaryByCsid = memo(function ConversationSummaryByCsid({ csid, initialSummary, view, onSummaryLoaded, isStale, className, }) {
    const featureFlag = useFeatureFlag(['conversation-summary']);
    const [summary, setSummary] = useState(initialSummary);
    const [fetchSummary, { data, isFetching }] = conversationsApi.useLazyReadOrGenerateSummaryQuery();
    const handleFeedback = useCallback(({ isUseful }) => {
        if (!(summary === null || summary === void 0 ? void 0 : summary.id)) {
            return;
        }
        if (isUseful) {
            segment.conversationSummaryFeedbackUseful({ summaryId: summary.id });
        }
        else {
            segment.conversationSummaryFeedbackNotUseful({
                summaryId: summary.id,
            });
        }
    }, [summary === null || summary === void 0 ? void 0 : summary.id]);
    const fetchSummaryAndEmitLoaded = useCallback((params) => fetchSummary(params).then((response) => {
        var _a;
        onSummaryLoaded === null || onSummaryLoaded === void 0 ? void 0 : onSummaryLoaded((_a = response.data) !== null && _a !== void 0 ? _a : null);
        return response;
    }), [fetchSummary, onSummaryLoaded]);
    const handleRequestRegenerate = useCallback(() => {
        fetchSummaryAndEmitLoaded({ csid, view, regenerate: true });
        (data === null || data === void 0 ? void 0 : data.id) &&
            segment.conversationSummaryRegenerateSummary({ summaryId: data.id });
    }, [csid, data === null || data === void 0 ? void 0 : data.id, fetchSummaryAndEmitLoaded, view]);
    useMount(() => {
        if (initialSummary || !featureFlag.conversationSummary) {
            return;
        }
        fetchSummaryAndEmitLoaded({ csid, view });
    });
    useUpdateEffect(() => {
        setSummary(data);
    }, [data]);
    const feedbackData = useMemo(() => ({
        csid,
        view,
        summary,
    }), [csid, summary, view]);
    if (!featureFlag.conversationSummary) {
        return null;
    }
    return (_jsx(ConversationSummary, { className: className, isFetching: isFetching, isStale: isStale, summary: summary, feedbackData: feedbackData, onFeedback: handleFeedback, onRequestRegenerate: handleRequestRegenerate }));
});
